import React from 'react';
import { Chip } from 'primereact/chip';
import { useTranslation } from 'react-i18next';

import { ActionStatus } from '../../types/actionTypes';
import { getActionStatusColor, getActionStatusLabel } from '../../utils/actionStatusConfig';
import { ActionStatusGlyph } from './actionStatusGlyphs';

interface ActionStatusChipProps {
  status: ActionStatus | null | undefined;
  className?: string;
  fontSize?: string;
}

const ActionStatusChip: React.FC<ActionStatusChipProps> = ({ status, className, fontSize = '0.72rem' }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={getActionStatusLabel(status, t)}
      icon={(options) => <ActionStatusGlyph key={options.iconProps.key} status={status} size={12} />}
      className={className}
      style={{
        color: '#fff',
        backgroundColor: getActionStatusColor(status),
        fontSize,
      }}
    />
  );
};

export default ActionStatusChip;
